export default __webpack_public_path__ + "static/media/icon_disclosure-circle-minus.46d0531c.svg";